import React, { useState, useEffect } from 'react';
import { membersAPI } from '../../../services/api';
import './MemberSelectionModal.css';

function MemberSelectionModal({ onClose, onSelect, currentMembers = [] }) {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selected, setSelected] = useState(new Set(currentMembers));

    useEffect(() => {
        fetchMembers();
    }, []);

    const fetchMembers = async () => {
        try {
            const response = await membersAPI.getAllMembers();
            const members = Array.isArray(response) ? response : [];
            setMembers(members);
        } catch (error) {
            setError(error.message || 'Failed to fetch members');
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const toggleMemberSelection = (memberId) => {
        const newSelected = new Set(selected);
        if (newSelected.has(memberId)) {
            newSelected.delete(memberId);
        } else {
            newSelected.add(memberId);
        }
        setSelected(newSelected);
    };

    const handleSubmit = () => {
        onSelect(Array.from(selected));
        onClose();
    };

    const filteredMembers = members.filter(member =>
        member.name?.toLowerCase().includes(searchQuery) || 
        member.firstName?.toLowerCase().includes(searchQuery) ||
        member.lastName?.toLowerCase().includes(searchQuery)
    );

    if (loading) return (
        <div className="modal-overlay">
            <div className="modal">
                <div className="modal-header">
                    <h2>Loading members...</h2>
                </div>
                <div className="members-list">
                    <div className="loading-spinner">Please wait...</div>
                </div>
            </div>
        </div>
    );

    if (error) return (
        <div className="modal-overlay">
            <div className="modal">
                <div className="modal-header">
                    <h2>Error</h2>
                </div>
                <div className="members-list">
                    <div className="error-message">{error}</div>
                </div>
                <div className="modal-footer">
                    <button onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );

    return (
        <div className="modal-overlay">
            <div className="modal">
                <div className="modal-header">
                    <h2>Select Members ({selected.size} selected)</h2>
                    <input
                        type="text"
                        placeholder="Search members..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
                <div className="members-list">
                    {filteredMembers.length === 0 ? (
                        <div className="no-results">No members found</div>
                    ) : (
                        filteredMembers.map(member => (
                            <div
                                key={member.id}
                                className={`member-item ${selected.has(member.id) ? 'selected' : ''}`}
                                onClick={() => toggleMemberSelection(member.id)}
                            >
                                {member.picture ? (
                                    <img src={member.picture} alt={member.name || `${member.firstName} ${member.lastName}`} className="member-avatar" />
                                ) : (
                                    <div className="member-avatar" style={{ backgroundColor: '#1a237e', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {(member.name?.[0] || member.firstName?.[0] || "U").toUpperCase()}
                                    </div>
                                )}
                                <span className="member-name">{member.name || `${member.firstName} ${member.lastName}`}</span>
                            </div>
                        ))
                    )}
                </div>
                <div className="modal-footer">
                    <button onClick={handleSubmit}>Confirm Selection</button>
                    <button onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

export default MemberSelectionModal; 